export const projectsData =[
    {
        title: "OLLIN IA",
        image: "",
        description: "Plataforma de inteligencia artificial diseñada para empoderar negocios mediante automatización de tareas, análisis de datos y chatbots. Soluciones IA a medida para optimizar procesos empresariales.",
        link: "https://ollinia.com/",
        technologies: ["AI", "Machine Learning", "Chatbots", "Automatización"]
    },
    {
        title: "Análisis de Cáncer de Mama",
        image: "",
        description: "Proyecto de clasificación de biopsias de cáncer de mama utilizando redes neuronales convolucionales (CNN) para diagnóstico automático. Implementado con TensorFlow para análisis de imágenes médicas y clasificación precisa de tejidos malignos y benignos.",
        link: "https://github.com/jrbeduardo/proyecto-cancer",
        technologies: ["Python", "TensorFlow", "CNN", "Deep Learning", "Computer Vision", "Medical Imaging"]
    },
    {
        title: "Administración de Spiders",
        image: "./spiderkeeper.svg",
        description: "Desarrollo de una aplicación web con panel de control para ejecutar y programar rastreadores web (spiders) en horarios definidos por el usuario. Permite automatizar tareas de scraping y monitoreo de múltiples fuentes desde una sola interfaz.",
        link: "https://github.com/jrbeduardo/SpiderKeeper.git",
        technologies: ["Flask", "Python", "Selenium", "SQLite", "Scrapy"]
    },
    {
        title: "Best Time to Call",
        image: "",
        description: "Modelo predictivo para identificar los horarios óptimos de contacto en campañas telefónicas, basado en historiales de interacción. Procesamiento masivo con PySpark de toda la base de clientes de Coppel, mejorando la tasa de contacto efectivo del call center.",
        technologies: ["PySpark", "SQL"]
    },
    {
        title: "Predictor de Ventas",
        image: "",
        description: "Modelo para estimar las ventas proyectadas a tres años en nuevas tiendas de Coppel. Utiliza variables como formato de tienda, coordenadas geográficas y superficie de venta. Permite a la Dirección Inmobiliaria evaluar la viabilidad de nuevas ubicaciones.",
        technologies: ["Flask", "PostGIS", "Python", "SQL", "GeoPandas"]
    },
    {
        title: "Name Matching",
        image: "",
        description: "Microservicio diseñado para detectar coincidencias de nombres en listas negras utilizando la distancia de Levenshtein. Se integró en distintos puntos del sistema (alta de clientes, app móvil, pagos de remesas), agilizando la validación y mejorando la seguridad.",
        technologies: ["FastAPI", "Python", "Levenshtein", "Docker"]
    },
    {
        title: "Marketing ROI",
        image: "",
        description: "Análisis y modelado del retorno de inversión (ROI) de campañas publicitarias mediante Marketing Mix Modeling. Permitió optimizar la asignación presupuestal entre canales como televisión, medios digitales y prensa.",
        technologies: ["R", "Flask", "Tableau", "Python", "Plumber"]
    },
    {
        title: "ML Diabetes",
        image: "./diabetes.svg",
        description: "Aplicación web que predice la probabilidad de diabetes usando regresión logística. El modelo toma como parámetros la glucosa (mg/dl), edad e índice de masa corporal (kg/m2) del usuario para generar una predicción precisa basada en datos médicos.",
        link: "http://jrbeduardo.pythonanywhere.com/",
        technologies: ["Python", "Flask", "Scikit-learn", "Logistic Regression", "Machine Learning", "HTML/CSS"]
    },
    {
        title: "Movies React",
        image: "./movies.svg",
        description: "Aplicación web que ayuda a revisar la información de distintas películas. Se usó React y la API de películas themoviedb.",
        link: "https://movies-eduardo.netlify.app/",
        technologies: ["React", "JavaScript", "API", "CSS"]
    }
]